import { tracking } from '@dazn/bootstrap-lib';

import { set } from './props';

export type AnyFunction = (...a: any[]) => any;

export const setFuncProp = <Fn extends AnyFunction>({
    window,
    trackUsage,
    propName,
    fn,
    decorator,
}: {
    window: Window & typeof globalThis;
    propName: string;
    trackUsage: tracking.TrackUsage | null;
    fn: Fn;
    decorator?: (fn: Fn, pn: string) => Fn;
}) => {
    const propertyPath = propName.split('.');
    const func = decorator ? decorator(fn, propName) : fn;

    if (!trackUsage) {
        set(window.dazn, propertyPath, func);
        return;
    }

    set(window.dazn, propertyPath, (...args: Parameters<typeof fn>) => {
        trackUsage({
            functionName: propName,
        });

        return func(...args);
    });
};
